import { useFormContext } from 'react-hook-form';
import { SelectionForm } from '../components/selection/TeiaQuantityTakeoffSelection';

export const useSelectionFormContext = () => {
  return useFormContext<SelectionForm>();
};
